import { ArgosClient } from '@jusbrasil-web/shared-argos-client'
import { fromSection } from '@jusbrasil-web/shared-utils-url'

import { JUSID_PLATFORM_WEB_AUTH, SIGNUP_EVENTS } from '../constants'
import type { AuthPageEventData } from './event-data'
import { buildSignUpFormPageSeenPayload } from './event-data'

interface ServerSideArgosRequest {
  headers: Record<string, string | string[] | undefined>
  url?: string
  cookies?: Partial<Record<string, string>>
}

function getFullUrl(req: ServerSideArgosRequest): string {
  const host = (req.headers.host as string | undefined) || 'localhost'
  const protocol = (req.headers['x-forwarded-proto'] as string | undefined) || 'http'
  const path = req.url || '/'
  return `${protocol}://${host}${path}`
}

export interface FireSignUpFormPageSeenParams {
  req: ServerSideArgosRequest
  email: string
  eventData?: AuthPageEventData
  type: 'default' | 'social'
  social?: string
}

/**
 * Fires UserAccount.SignUpFormPageSeen server-side to Argos.
 * Consistent with Bifrost implementation - event is triggered on page load (GET).
 */
export function fireSignUpFormPageSeenServer({
  req,
  email,
  eventData,
  type,
  social,
}: FireSignUpFormPageSeenParams): void {
  const sourceUrl = getFullUrl(req)
  const userAgent = (req.headers['user-agent'] as string) || undefined
  const deviceId = (req.cookies?.jdid as string | undefined) ?? null
  const referrer = (req.headers.referer as string | undefined) || sourceUrl

  const payload = buildSignUpFormPageSeenPayload({
    email,
    eventData,
    jusidPlatform: JUSID_PLATFORM_WEB_AUTH,
    type,
    social,
    sourceUrl,
    userAgent,
    deviceId,
  })

  const source = fromSection(referrer) ?? referrer
  const properties = {
    ...payload,
    referrer,
    source,
  }
  const headers = req.headers.cookie ? { cookie: req.headers.cookie } : {}

  try {
    new ArgosClient().send(undefined, SIGNUP_EVENTS.SIGN_UP_FORM_PAGE_SEEN, properties, headers)
  } catch (err) {
    console.error('[auth] fireSignUpFormPageSeenServer failed:', err)
  }
}
